import { render, staticRenderFns } from "./GlobalSubPhaseLessonsGroupedByPhase.vue?vue&type=template&id=3b354156&scoped=true&"
import script from "./GlobalSubPhaseLessonsGroupedByPhase.vue?vue&type=script&lang=ts&"
export * from "./GlobalSubPhaseLessonsGroupedByPhase.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSubPhaseLessonsGroupedByPhase.vue?vue&type=style&index=0&id=3b354156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b354156",
  null
  
)

export default component.exports